import React, { useState } from "react";
import { Formik, Form } from "formik";
import { Button } from "reactstrap";
import NameInput from "../../common/NameInput";
import RadioGroup from "../../common/RadioGroup";
import AlphaNumericInput from "../../common/AlphaNumericInput";
import DropdownInput from "../../common/DropdownInput";
import SingleCheckbox from "../../common/SingleCheckbox"; // Import SingleCheckbox component
import DimensionInput from "../../common/DimensionInput";
import AmountInput from "../../common/AmountInput";
import WeightInput from "../../common/WeightInput";
import TextareaInput from "../../common/TextareaInput";
import DatePickerInput from "../../common/DatePickerInput";
import EmailInput from "../../common/EmailInput";
import PhoneNumberInput from "../../common/PhoneNumberInput";
import UrlInput from "../../common/UrlInput";

const AddForm = () => {
    const [validateTrigger, setValidateTrigger] = useState(false);

    const initialValues = {
        name: "",
        selectedOption: "",
        alphanumeric: "",
        dropdown: "",
        singleCheckbox: false, // Initialize checkbox value
        dimensions: { length: '', width: '', height: '' },
        amount: "",
        weight: "",
        description: "",
        selectedDate: null,
        email: "", 
        phone: "",
        url: "",
    };

    const handleSubmit = (values) => {
        console.log("Submitted Values:", values);
    };

    return (
        <div className="page-content">
            <br />
            <br />
            <br />
            <br />
            <br />
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setValidateTrigger(true);
                    setSubmitting(false);
                    handleSubmit(values);
                }}
            >
                {(formik) => (
                    <Form>
                        <NameInput
                            name="name"
                            required
                            showHelp={true}
                            helpText="Please enter your name."
                            requiredErrorMessage="Please enter your name."
                            validateTrigger={validateTrigger}
                            onChange={formik.handleChange}
                            value={formik.values.name}
                        />
                        <RadioGroup
                            label="Select an Option"
                            name="selectedOption"
                            options={[
                                { label: "Option 1", value: "option1" },
                                { label: "Option 2", value: "option2" },
                                { label: "Option 3", value: "option3" },
                            ]}
                            required
                            validateTrigger={validateTrigger}
                            requiredErrorMessage="Please select one option."
                            onChange={(value) => formik.setFieldValue("selectedOption", value)}
                        />
                        <AlphaNumericInput
                            name="alphanumeric"
                            label="Alphanumeric Input"
                            placeholder="Enter alphanumeric text"
                            required
                            validateTrigger={validateTrigger}
                            requiredErrorMessage="This field is required."
                            validationErrorMessage="Only letters and numbers are allowed."
                            minLengthErrorMessage="Input must be at least 3 characters."
                            showHelp={true}
                            helpText="Please enter an alphanumeric string."
                            onChange={formik.handleChange}
                            value={formik.values.alphanumeric}
                        />
                        <DropdownInput
                            label="Select Dropdown Option"
                            name="dropdown"
                            id="dropdownInput"
                            options={[
                                { label: "Dropdown Option 1", value: "dropdownOption1" },
                                { label: "Dropdown Option 2", value: "dropdownOption2" },
                                { label: "Dropdown Option 3", value: "dropdownOption3" },
                            ]}
                            required={true}
                            showHelp={true}
                            validateTrigger={validateTrigger}
                            requiredErrorMessage="Please select an option."
                            onChange={(selectedOption) => formik.setFieldValue("dropdown", selectedOption ? selectedOption.value : "")}
                            onBlur={() => formik.setFieldTouched("dropdown", true)}
                            defaultSelectedKey={formik.values.dropdown}
                            placeholder="Please select an option"
                        />
                        <SingleCheckbox
                            name="singleCheckbox"
                            required
                            label="I agree to the terms and conditions"
                            validateTrigger={validateTrigger}
                            onChange={(checked) => formik.setFieldValue("singleCheckbox", checked)}
                        />

                        <DimensionInput
                            label="Enter Dimensions"
                            name="dimensions"
                            value={formik.values.dimensions}
                            validateTrigger={validateTrigger}
                            required
                            requiredErrorMessage="Dimensions are required."
                            minLength={10}
                            maxLength={1000}
                            rangeErrorMessage="Dimensions must be between 10 and 1000 cm."
                            invalidErrorMessage="Please enter valid dimensions."
                        />
                        <AmountInput
                            label="Amount"
                            name="amount"
                            value={formik.values.amount}
                            required={true}
                            min={1}
                            max={100000}
                            validateTrigger={validateTrigger}
                            onChange={(e) => formik.setFieldValue("amount", e.target.value)}
                            onBlur={() => formik.setFieldTouched("amount", true)}
                        />
                        <WeightInput
                            name="weight"
                            value={formik.values.weight}
                            unit={formik.values.unit}
                            required={true}
                            minValue={1}
                            maxValue={200}
                            validateTrigger={validateTrigger}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        <TextareaInput
                            label="Description"
                            name="description"
                            value={formik.values.description}
                            required={true}
                            maxLength={500}
                            validateTrigger={validateTrigger}
                            onChange={(e) => formik.setFieldValue("description", e.target.value)}
                            onBlur={() => formik.setFieldTouched("description", true)}
                            placeholder="Enter a description"
                            showHelp={true}
                            helpText="Please enter a description of your item."
                            disabled={false} // Set to true if you want to disable
                        />

<DatePickerInput
                            name="selectedDate"
                            value={formik.values.selectedDate}
                            required={true}
                            validateTrigger={validateTrigger}
                            onChange={formik.setFieldValue}
                            onBlur={formik.handleBlur}
                            dateRange={{ minDate: new Date() }}
                        />

<EmailInput
                            label="Email"
                            name="email"
                            value={formik.values.email}
                            required={true}
                            businessEmailOnly={true} // Set true if only business emails are allowed
                            validateTrigger={validateTrigger}
                            onChange={(e) => formik.setFieldValue("email", e.target.value)}
                            onBlur={() => formik.setFieldTouched("email", true)}
                            requiredErrorMessage="Email is required."
                            validationErrorMessage="Please enter a valid email address."
                            businessEmailErrorMessage="Only business emails are allowed."
                        />

<PhoneNumberInput
                            label="Phone Number"
                            name="phone"
                            value={formik.values.phone}
                            required={true}
                            validateTrigger={validateTrigger}
                            onChange={(value) => formik.setFieldValue("phone", value)}
                            onBlur={() => formik.setFieldTouched("phone", true)}
                        />

<UrlInput
                            name="url"
                            id="url"
                            label="Website URL"
                            required={true}
                            placeholder="Enter website URL"
                            validateTrigger={validateTrigger}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.url}
                            helpText="Please provide a valid website URL."
                            showHelp={true}
                            requiredErrorMessage="URL is required."
                            validationErrorMessage="Please enter a valid URL."
                        />


                        <Button type="submit" color="primary">Submit</Button>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default AddForm;
